import PropTypes from 'prop-types';

export const OrderGridFilterPropType = PropTypes.shape({
  booleanFilters: PropTypes.arrayOf(
    PropTypes.shape({
      column: PropTypes.string,
      value: PropTypes.bool,
    }),
  ),
  collectionFilters: PropTypes.arrayOf(
    PropTypes.shape({
      column: PropTypes.string,
      isIn: PropTypes.bool,
      isNull: PropTypes.bool,
      values: PropTypes.arrayOf(PropTypes.string),
    }),
  ),
  dateTimeFilters: PropTypes.arrayOf(
    PropTypes.shape({
      column: PropTypes.string,
      value: PropTypes.string,
      operator: PropTypes.string,
    }),
  ),
  numericFilters: PropTypes.arrayOf(
    PropTypes.shape({
      column: PropTypes.string,
      value: PropTypes.string,
      operator: PropTypes.string,
    }),
  ),
  stringFilters: PropTypes.arrayOf(
    PropTypes.shape({
      column: PropTypes.string,
      value: PropTypes.string,
      operator: PropTypes.string,
    }),
  ),
});

/**
 * @typedef {object} OrderGridFilterItemPropType
 * @property {string} column
 * @property {string} value
 */

/**
 * @typedef {object} OrderGridFilterItemWithOperatorPropType
 * @property {string} column
 * @property {string} value
 * @property {string} operator
 */

/**
 * @typedef {object} OrderGridFilterItemWithMultipleValuesPropType
 * @property {string} column
 * @property {boolean} isIn
 * @property {boolean} isNull
 * @property {string[]} values
 */

/**
 * @typedef {object} OrderGridFilterPropType
 * @property {OrderGridFilterItemPropType[]} booleanFilters
 * @property {OrderGridFilterItemWithMultipleValuesPropType[]} collectionFilters
 * @property {OrderGridFilterItemWithOperatorPropType[]} dateTimeFilters
 * @property {OrderGridFilterItemWithOperatorPropType[]} numericFilters
 * @property {OrderGridFilterItemWithOperatorPropType[]} stringFilters
 */
